import "./SentInterest.css";
import React from "react";
import { Paper } from "@material-ui/core";

const SentInterest = () => {
  const paperStyle = {
    height: "auto",
    width: "auto",
    maxWidth: "100%",
    margin: "2% 2%",
    boxShadow: "0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24)",
    borderRadius: "5px",
  };
  return (
    <div className="container sentinterest-container">
      <Paper style={paperStyle}>
        <div className="col headers-container">
          <div className="row justify-content-end header-row">
            <div className="col-8 logo-header">
              <a href="https://www.b-e.org.il">
                <img
                  src={require(`../../Images/Icons/BeitEkstein.jpg`)}
                  alt="Image"
                  loading="lazy"
                  width="85%"
                  className="logo-header-image"
                />
              </a>
            </div>
            <div className="col-2"></div>
          </div>
        </div>
        <div className="col title-block">
          <h1 className="interested-first-title">מעולה!</h1>
          <h2 className="interested-second-title">
            תודה שהגשת מועמדות. <br /> נהיה איתך בקשר ממש בקרוב.
          </h2>
        </div>
        <div className="col main-image">
          <img
            src={require(`../../Images/Other/Other1.png`)}
            width="90%"
            height="100%"
          />
        </div>
        <div className="col below-image-text">
          <span className="blue-text">נ.ב.</span> יש לנו עוד <br /> משרות בשבילך
          <br />
          <br />
        </div>
        <div className="col footer-text container">
          <a href="https://b-e.org.il/%d7%a7%d7%a8%d7%99%d7%99%d7%a8%d7%94/%d7%97%d7%99%d7%a4%d7%95%d7%a9-%d7%9e%d7%a9%d7%a8%d7%95%d7%aa/">
            <div className="blue-text more-jobs">
              <u>
                לצפייה במשרות<i className="description-arrow left"></i>
              </u>
            </div>
          </a>
        </div>
      </Paper>
    </div>
  );
};

export default SentInterest;
